<template>
  <div class="sources-page">
    <header class="subpages-header">
      <router-link to="/map"
        ><button class="back-button">
          <md-icon class="md-size">keyboard_backspace</md-icon>Back to map
        </button></router-link
      >
      <h2>Sources and citations</h2>
      <span></span>
    </header>
    <main></main>
    <!-- <div class="relative-credits-container">
      <a href="http://zevross.com/" class="about-this-map-link"
        >Map application created by ZevRoss Spatial Analysis</a
      >
    </div> -->
  </div>
</template>

<script>
export default {
  name: "hei-sources-page",
};
</script>

<style lang="scss">
body,
html {
  background-color: #fff !important;
}
</style>
